<!--盖章文件-->
<template>
	<el-card v-if="isShowFile" class="u-m-b-20" header="投保盖章文件">
		<avue-form
			ref="fileForm"
			v-model="formFileConfirm"
			:option="optionFileConfirm"
			:upload-before="onUploadBefore"
			@submit="onSubmitFileConfirm">
			<template #insureConfirmUrl="{}">
				<el-button v-if="isNeedDeclareStart" type="primary" @click="onDownLoadTemp">下载模板</el-button>
				<div v-else>
					<div>
						按照相关监管要求，录单信息（被保企业、方案、人员等）变更后，务必
						<span class="red-bold">重新下载盖章件，并线下盖章确认！</span>
					</div>
					<div>
						你可以先暂存保单，等文件盖章后
						<span class="red-bold">从暂存列表继续录单流程。</span>
					</div>
				</div>
			</template>
			<template #menuForm="{}">
				<el-button v-if="!optionFileConfirm.submitBtn" icon="el-icon-edit" @click="onIsSubmit(false)">修改</el-button>
			</template>
		</avue-form>
	</el-card>
</template>
<script>
import {baseFileConfirmOption, baseFileConfirmOptionAnZe, getCompleteOption} from 'meibao-insure/src/option/baseOption'
import {openPdfUrl} from 'meibao-insure/src/util/downloadUtils'

export default {
	name: 'formFileConfirmNew',
	data() {
		return {
			formFileConfirm: {
				statementImg: '',
				insureConfirmSample: '',
				insureConfirmUrl: '',
			},
			optionFileConfirm: {},
			isShowFile: false,
			unitFormData: {},
			planFormData: {},
			//存储盖章文件
			fileConfirmMap: new Map(),
			lastPlanType: 0,
			isShowHint: true,
			insureConfirmMd5: '',
			doneData: null,
		}
	},
	props: {
		//盖章文件数据
		declareFormData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		productId: {
			type: String | Number,
			required: true,
		},
		sourceProductId: {
			type: String | Number,
			required: true,
		},
		insureType: {
			type: Number | String,
			required: true,
		},
		//true盖章文件前置， 泰康需要后置
		isNeedDeclareStart: Boolean,
	},
	watch: {
		declareFormData: {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					//处理盖章文件的option
				}
			},
			immediate: true,
		},
	},
	mounted() {
		//设置option
		this.onSetFileOption()
	},
	methods: {
		//设置option 不是每个险种都需要上传盖章文件，所以需要的才处理。
		onSetFileOption() {
			if (this.validatenull(this.optionFileConfirm)) {
				let tempOption = this.isNeedDeclareStart
					? baseFileConfirmOption(this.declareFormData)
					: baseFileConfirmOptionAnZe(this.declareFormData)
				this.optionFileConfirm = getCompleteOption(this.declareFormData, tempOption)
			}
		},
		onUploadBefore({type = '', size = 0}, done, loading) {
			if (type !== 'image/jpeg' && type !== 'image/png') {
				this.$message.error('上传图片只支持JPEG或PNG格式!')
				loading()
				return
			}
			if (size / 1024 / 1024 > 5) {
				this.$message.error('请上传大小不超过5Mb的jpg/png文件')
				loading()
				return
			}
			done()
		},
		onSubmitFileConfirm(form, done) {
			//根据企业信息确认数据
			this.$emit('onSubmittedData', {type: 8, statementImg: this.formFileConfirm.statementImg})
			this.doneData = done
			setTimeout(() => {
				this.onDealDone()
			}, 5000)
		},
		//去除loading
		onDealDone() {
			if (this.doneData) {
				this.doneData()
				this.doneData = null
			}
		},
		//传递进来的不一样，则处理
		onDealFile({insureConfirmUrl = '', insureConfirmSample = '', insureConfirmMd5 = '', isMustRefresh = false}) {
			//解构
			let {statementImg = ''} = this.formFileConfirm
			//处理是否展示
			if (insureConfirmUrl === '') {
				if (this.isShowFile || statementImg) {
					//不存在
					this.formFileConfirm.statementImg = ''
					this.formFileConfirm.insureConfirmSample = ''
					this.formFileConfirm.insureConfirmUrl = ''
					this.insureConfirmMd5 = ''
					if (this.isShowFile) {
						if (!this.optionFileConfirm.submitBtn) {
							this.onIsSubmit(false)
						}
						this.isShowFile = false
					}
				}
				return
			}
			this.isShowFile = insureConfirmUrl !== ''
			if (insureConfirmUrl !== '') {
				// 限投状态 0.完全禁止 1.允许 2.上传声明
				if (this.isShowHint) {
					this.isShowHint = false
					this.$message.warning('请上传投保人声明盖章文件！')
					// this.$alert('为了保证您能顺利投保成功，请上传投保人声明盖章文件！', '提示').then(() => {})
				}
			}
			//通过md5判断是否为同一个盖章文件了！！！
			if (!this.insureConfirmMd5 || this.insureConfirmMd5 !== insureConfirmMd5 || isMustRefresh) {
				//先提示
				if (this.formFileConfirm.statementImg !== '' && !isMustRefresh) {
					this.$alert('上传的投保声明盖章文件内容不一致，需要下载模板重新盖章！', '提示', {
						confirmButtonText: '我知道了',
						closeOnClickModal: false,
					}).then(() => {
						this.formFileConfirm.statementImg = ''
						if (!this.optionFileConfirm.submitBtn) {
							this.onIsSubmit(false)
						}
					})
				}
				this.formFileConfirm.insureConfirmSample = insureConfirmSample
				this.formFileConfirm.insureConfirmUrl = insureConfirmUrl
				this.insureConfirmMd5 = insureConfirmMd5
			}
		},
		//下载模板
		onDownLoadTemp() {
			openPdfUrl(this.formFileConfirm.insureConfirmUrl)
		},
		//是否确定 true 确定
		onIsSubmit(type) {
			if (this.optionFileConfirm.submitBtn === !type) {
				return
			}
			this.optionFileConfirm.submitBtn = !type
			this.optionFileConfirm.column.forEach((item, index) => {
				if (item.prop !== 'insureConfirmSample') {
					item.disabled = type
				}
			})
			if (type) {
				this.$message.success('投保声明盖章件校验成功！')
			}
			this.onDealDone()
		},
		//判断是否需要上传，并且上传成功
		isConfirm() {
			return this.isShowFile && this.optionFileConfirm.submitBtn
		},
		onGetSubFilesData() {
			return this.isShowFile ? this.formFileConfirm.statementImg || '' : ''
		},
		onSetFilesData(statementImg = '') {
			this.formFileConfirm.statementImg = statementImg
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	border: transparent;
}

::v-deep .el-upload--picture-card {
	border: transparent;
}
</style>
